import React, { useEffect } from 'react';
import Loader from '../../utils/Loader';
import {
	handleInputChange,
	toggleMicStatus,
	updateLicenseKey,
	checkNotify,
	toggleNotification,
} from '../../redux/settings/settings.actions';
import { toggleMicPermission } from '../../redux/testPage/testPage.actions';
import {
	setShowEcho,
	setShowPermitMic,
} from '../../redux/utilities/utils.actions';
import { connect } from 'react-redux';
import PermitMicModal from '../common/permitMic';
import Card from 'react-bootstrap/Card';

const License = ({
	setShowPermitMic,
	data: {
		speechIsOn,
		licenseKey,
		organisationName,
		Msg,
		speechOn,
		isNotify,
		notificationText,
	},
	setShowEcho,
	toggleNotification,
	handleInputChange,
	toggleMicStatus,
	updateLicenseKey,
	checkNotify,
	toggleMicPermission,
}) => {
	useEffect(() => {
		Loader.hide();
		checkNotify();
	}, [checkNotify]);

	const speechModalShow = () => {
		if (!speechIsOn) {
			navigator.mediaDevices
				.getUserMedia({ audio: true })
				.then(function success() {
					setShowEcho(true);
					toggleMicPermission(true);
				})
				.catch(function failure() {
					toggleMicPermission(false);
					setShowPermitMic(true);
				});
		}
	};
	return (
		<div>
			<div className="message_box">{Msg}</div>
			<div className="row">
				<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
					<Card>
						<Card.Body>
							<Card.Title>
								<div className="page-header-left">Settings</div>
							</Card.Title>
							<div className="group settings_section">
								<input
									type="text"
									name="licenseKey"
									id="LicenseKey"
									required
									value={licenseKey}
									onChange={(e) => {
										handleInputChange(e);
									}}
								/>
								<span className="highlight"></span>
								<span className="bar"></span>
								<label>Licence Key *</label>
								<span>Organisation: {organisationName}</span>
							</div>
							<button
								aria-label="save"
								onClick={() => {
									updateLicenseKey();
								}}
								className="btn-setting-save"
							>
								SAVE
							</button>
						</Card.Body>
					</Card>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
					<Card>
						<Card.Body>
							<div className="push-noti">
								Activate MIC
								<label className="switch">
									<input
										className="switch-input"
										type="checkbox"
										{...speechOn}
										onClick={toggleMicStatus}
									/>
									<span
										className="switch-label"
										data-on="On"
										data-off="Off"
										onClick={speechModalShow}
									></span>
									<span className="switch-handle"></span>
								</label>
							</div>
							<div className="push-noti">
								Notifications
								<label className="switch">
									<input
										className="switch-input"
										type="checkbox"
										onClick={toggleNotification}
										{...isNotify}
									/>
									<span className="switch-label" data-on="On" data-off="Off"></span>
									<span className="switch-handle"></span>
								</label>
							</div>
							<p>{notificationText}</p>
						</Card.Body>
					</Card>
				</div>
				<PermitMicModal />
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		handleInputChange: (event) => dispatch(handleInputChange(event)),
		toggleMicStatus: () => dispatch(toggleMicStatus()),
		updateLicenseKey: () => dispatch(updateLicenseKey()),
		checkNotify: () => dispatch(checkNotify()),
		toggleNotification: () => dispatch(toggleNotification()),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setShowEcho: (val) => dispatch(setShowEcho(val)),
		setShowPermitMic: (val) => dispatch(setShowPermitMic(val)),
	};
};

const mapStateToProps = (state) => {
	return {
		data: state.rootReducer.settingsDetails,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(License);
